import React from 'react';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import TextArea from '../fields/TextArea';
import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';

const DeviceDescriptionPage = ({ handleSubmit, t }) => (
  <React.Fragment>
    <Heading text={t('device_description.title')} />
    &nbsp;&nbsp;&nbsp;
    <form onSubmit={handleSubmit}>
      <Field name="Description" component={TextArea} />
    </form>
    <Paragraph topMargin={37}>{t('device_description.hint')}</Paragraph>
  </React.Fragment>
);

export default translate()(DeviceDescriptionPage);
